var React = require('react');

function IconHamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.91 7C2.406 7 2 6.552 2 6s.407-1 .91-1h18.18c.503 0 .91.448.91 1s-.407 1-.91 1H2.91zm0 6c-.503 0-.91-.448-.91-1s.407-1 .91-1h18.18c.503 0 .91.448.91 1s-.407 1-.91 1H2.91zM12 19c-.502 0-.91-.448-.91-1s.408-1 .91-1h9.09c.503 0 .91.448.91 1s-.407 1-.91 1H12z"}));
}

IconHamburger.defaultProps = {"viewBox":"0 0 24 24","name":"Hamburger"};

module.exports = IconHamburger;

IconHamburger.default = IconHamburger;
